import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';
import _ from 'lodash';
import numeral from 'numeral';

import AvatarProfile from '../../components/avatar';
import { checkUserIsTeamMember } from '../../utils/role-service';
import Timeline from '../../components/timeline';

import { setUnreadMessageCount } from './actions';
import { getBriefStatus, getContractStatus } from '../../utils/document-status-functions';
import { getDeliverablesStatus } from '../../utils/deliverable-status-functions';
import { reportError } from '../../utils/error-handling-service';
import BudgetReadonly from '../../components/budget-readonly';

class DiscussionCard extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  viewDiscussion = discussion => () => {
    this.context.router.push(`/campaign/discussion/${discussion.get('id')}`);
  };

  render() {
    const {
      campaign,
      members,
      pendingInvitations,
      discussion,
      size,
      isCreatorDiscussion,
      myUserRole,
      influencer,
    } = this.props;

    const currentBrief = discussion.get('currentBrief') ? discussion.getIn(['documents', discussion.get('currentBrief')]) : null;
    const currentContract = discussion.get('currentContract') ? discussion.getIn(['documents', discussion.get('currentContract')]) : null;
    const signedContract = discussion.get('signedContract') ? discussion.getIn(['documents', discussion.get('signedContract')]) : null;
    const deliverable = discussion.get('deliverables') || null;

    const budget = discussion.get('budget');
    const budgetStatus = discussion.get('budgetStatus');

    const docsStatus = {
      brief: getBriefStatus(currentBrief),
      contract: getContractStatus(currentContract, signedContract),
    };

    const deliverableStatus = getDeliverablesStatus(deliverable);

    const isUserTeamMember = checkUserIsTeamMember(myUserRole);

    const unreadMessageCount = discussion.get('unreadMessageCount');
    const organisations = discussion.get('organisations') || [];

    const influencers = {
      laurieb: {
        name: 'Laurie Bantin',
        thumbnail: 'https://scontent.cdninstagram.com/t51.2885-19/s320x320/14515731_1860820994152776_4329187327671795712_a.jpg',
        youtubeCount: 1000,
        instagramCount: 1000,
        facebookCount: 1000,
        twitterCount: 1000,
        totalSocialReach: 4000,
      },
      fleurdeforce: {
        name: 'Fleur Bell',
        thumbnail: 'https://yt3.ggpht.com/-l2_MNdgQUkk/AAAAAAAAAAI/AAAAAAAAAAA/fZvKNfxvW3I/s240-c-k-no-rj-c0xffffff/photo.jpg',
        youtubeCount: 1000000,
        instagramCount: 793000,
        facebookCount: 134000,
        twitterCount: 324000,
        totalSocialReach: 3000000,
      },
      amelialiana: {
        name: 'Amelia Liana',
        thumbnail: 'https://yt3.ggpht.com/-Uuolk7bSoiI/AAAAAAAAAAI/AAAAAAAAAAA/SV_4_QOQToc/s240-c-k-no-rj-c0xffffff/photo.jpg',
        youtubeCount: 457000,
        instagramCount: 303000,
        facebookCount: 0,
        twitterCount: 113000,
        totalSocialReach: 874000,
      },
      'patricia bright': {
        name: 'Patricia Bright',
        thumbnail: 'https://yt3.ggpht.com/-whml5kuDoP8/AAAAAAAAAAI/AAAAAAAAAAA/qUiBGxo3l1U/s240-c-k-no-rj-c0xffffff/photo.jpg',
        youtubeCount: 1000000,
        instagramCount: 473000,
        facebookCount: 0,
        twitterCount: 77000,
        totalSocialReach: 1600000,
      },
      zoella: {
        name: 'Zoe Sugg',
        thumbnail: 'https://yt3.ggpht.com/-n8WEOU4tnok/AAAAAAAAAAI/AAAAAAAAAAA/-8oUr21Iido/s240-c-k-no-rj-c0xffffff/photo.jpg',
        youtubeCount: 16400000,
        instagramCount: 7900000,
        facebookCount: 2700000,
        twitterCount: 8100000,
        totalSocialReach: 35100000,
      },
      funforlouis: {
        name: 'Louis Cole',
        thumbnail: 'https://yt3.ggpht.com/-wmWCuxokuSY/AAAAAAAAAAI/AAAAAAAAAAA/xuzLxJLwT5M/s240-c-k-no-rj-c0xffffff/photo.jpg',
        youtubeCount: 1900000,
        instagramCount: 1400000,
        facebookCount: 421000,
        twitterCount: 866000,
        totalSocialReach: 4600000,
      },
      callux: {
        name: 'Callum McGinley',
        thumbnail: 'https://yt3.ggpht.com/-V-5kI2sfpd8/AAAAAAAAAAI/AAAAAAAAAAA/2ocZdYE0fpI/s240-c-k-no-rj-c0xffffff/photo.jpg',
        youtubeCount: 2200000,
        instagramCount: 556000,
        facebookCount: 19000,
        twitterCount: 627000,
        totalSocialReach: 3400000,
      },
      stevebooker: {
        name: 'Steve Booker',
        thumbnail: 'https://yt3.ggpht.com/-qjiv0wmxYec/AAAAAAAAAAI/AAAAAAAAAAA/jUi52wI5IBU/s240-c-k-no-mo-rj-c0xffffff/photo.jpg',
      },
      mrbenbrown: {
        name: 'Ben Brown',
        thumbnail: 'https://yt3.ggpht.com/-4Jjs_8d231s/AAAAAAAAAAI/AAAAAAAAAAA/EnEH_q1MEbQ/s240-c-k-no-rj-c0xffffff/photo.jpg',
      },
      soniatravels: {
        name: 'Sonia Wright',
        thumbnail: 'https://yt3.ggpht.com/-KIdCZCo7-mM/AAAAAAAAAAI/AAAAAAAAAAA/anL0kIA_J64/s240-c-k-no-rj-c0xffffff/photo.jpg',
      },
      'hey nadine': {
        name: 'Nadine Smith',
        thumbnail: 'https://yt3.ggpht.com/-IE9zWKgAAIA/AAAAAAAAAAI/AAAAAAAAAAA/MgaQTBTMi-0/s240-c-k-no-rj-c0xffffff/photo.jpg',
      },
    };

    const localInfluencer = influencer || influencers[_.toLower(discussion.get('name'))];

    const localStyles = {
      borderBottom: '1px solid #eee',
      paddingBottom: '10px',
    };

    const budgetStyles = {
      float: 'right',
      width: '200px',
    };

    const bc1Styles = {
      paddingTop: 0,
      paddingBottom: 6,
    };

    const pendingStyle = {
      backgroundColor: '#ddd',
      padding: '10px 0',
      textAlign: 'center',
    };

    const dataWrapper = {
      width: '300px !important',
    };
    const commaFormat = num => numeral(num).format('0a');
    const isInfluencerMember = joined => joined.find(member => member.get('role') === 'INFLUENCER');
    const influencerJoined = isInfluencerMember(members);

    return (

      <div className={size === 'large' ? 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' : 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-3-6 grid-xl-3-6'}>
        <div className="box wide clickable">
          <div className="box-content-one">

            <div className="title-row" style={localStyles}>
              <div className="flex-spacer">

                <table width="100%">
                  <tr>
                    <td>
                      <h3>
                        { isCreatorDiscussion && localInfluencer &&
                          <div>
                            <Image src={localInfluencer.thumbnail} size="tiny" shape="circular" inline spaced />
                            {localInfluencer.name}
                            <span className="small light">&nbsp;{discussion.get('name')}</span>
                          </div>
                        }


                        { !(isCreatorDiscussion && localInfluencer) &&
                          <div>
                            {discussion.get('name')}
                          </div>
                        }
                      </h3>
                    </td>
                    <td>
                      { isCreatorDiscussion && localInfluencer &&

                        <div className="flex" styles={dataWrapper}>
                          <div className="space align-center">
                            <img src="/icons/facebook.svg" alt="Facebook" />
                            <p className="light">{commaFormat(localInfluencer.facebookCount)}</p>
                          </div>
                          <div className="space align-center">
                            <img src="/icons/instagram.svg" alt="Instagram" />
                            <p className="light">{commaFormat(localInfluencer.instagramCount)}</p>
                          </div>
                          <div className="space align-center">
                            <img src="/icons/twitter.svg" alt="Twitter" />
                            <p className="light">{commaFormat(localInfluencer.twitterCount)}</p>
                          </div>
                          <div className="space align-center">
                            <img src="/icons/youtube.svg" alt="YouTube" />
                            <p className="light">{commaFormat(localInfluencer.youtubeCount)}</p>
                          </div>
                          <div className="space" />
                          <div className="item align-center">
                            <p><b>Total Reach</b></p>
                            <p className="light">{commaFormat(localInfluencer.totalSocialReach)}</p>
                          </div>
                        </div>

                      }
                    </td>
                  </tr>
                </table>
              </div>
              <div className="flex-item">
                { unreadMessageCount > 0 &&
                <div className="unread-message">
                  <img src="/icons/unread.svg" alt="Unread messages" />
                  <p className="small">{unreadMessageCount}</p>
                </div>
                }
              </div>

            </div>
          </div>

          { !isCreatorDiscussion &&
          <div className="box-content-one">
            <div className="profile-row">
              <ul>
                { members.map(member => {
                  const memberId = member.get('id');
                  const name = member.get('name');
                  // TODO This really shouldn't be done via organisation ID
                  const role = member.get('role');
                  const email = member.get('email');
                  let organisationId = null;
                  // Avoids circular issue in data tree
                  if (checkUserIsTeamMember(role)) {
                    organisationId = campaign.getIn(['owner', 'id']);
                  } else {
                    organisationId = member.getIn(['organisation', 'id']);
                  }

                  const userPartOfDiscussion = organisations.find(
                    organisation => organisationId === organisation.get('id'),
                  );

                  if (userPartOfDiscussion) {
                    return (
                      <li key={memberId}>
                        <span className="clickable" onClick={this.viewDiscussion.bind(this, discussion)}>
                              joined: <AvatarProfile name={name} role={role} email={email} size={44} className="clickable" />
                        </span>
                      </li>
                    );
                  }
                  return '';
                })}
                {/* TODO Remove until collab members stored correctly
                    <li key={1} className="discussion-break">
                      <div className="vertical-break">
                      </div>
                    </li> */}
                { organisations.map(organisation => {
                  const organisationId = organisation.get('id');
                  const pendingInvitationsList = pendingInvitations.get(organisationId);
                  return (
                    <span key={organisationId}>
                      { pendingInvitationsList &&
                            pendingInvitationsList.map(member => {
                              const memberId = member.get('id');
                              const name = member.get('name');
                              const role = member.get('role');
                              const email = member.get('email');

                              return (
                                <li key={memberId}>
                                  <span className="clickable" onClick={this.viewDiscussion.bind(this, discussion)}>
                                    pending: <AvatarProfile name={name} role={role} email={email} pending size={44} className="clickable" />
                                  </span>
                                </li>
                              );
                            })}
                    </span>
                  );
                })}
              </ul>
            </div>
          </div>
          }

          { isCreatorDiscussion &&

          <div className="box-content-one" style={bc1Styles}>

            { influencerJoined
              ?
                <div>
                <div style={budgetStyles}>
                    <BudgetReadonly budget={budget} budgetStatus={budgetStatus} />
                  </div>

                <Timeline
                    vertical={false}
                    docsStatus={docsStatus}
                    deliverableStatus={deliverableStatus}
                    isUserTeamMember={isUserTeamMember}
                  />
              </div>
              :
              <div style={pendingStyle}>
                  <p>Invitation still pending...</p>
                </div>
            }

          </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  campaign: state.campaign.get('campaign'),
  members: state.members.get('members'),
  pendingInvitations: state.members.get('pendingInvitations'),
  userData: state.userData.get('userData'),
  myUserRole: state.campaign.get('myUserRole'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetUnreadMessageCount: (discussionId, unreadMessageCount) => dispatch(setUnreadMessageCount(discussionId, unreadMessageCount)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscussionCard);



/** WEBPACK FOOTER **
 ** ./src/containers/discussion-card/index.js
 **/